import { Link } from 'react-router-dom';

export default function GiftBanner() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/f935ad373ab11652985830cd18783d78.webp"
          alt="Patriotic wind spinner gift idea"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="container-main relative z-10 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-[#2c2a4a] mb-5">
          The Gift That Moves Them
        </h2>
        <p className="text-lg md:text-xl text-[#2c2a4a]/90 font-sans mb-10 max-w-xl mx-auto">
          A beautiful, lasting gift for the garden they love.
        </p>
        <Link
          to="/collections/wind-spinners"
          className="inline-block bg-copper text-white font-sans font-semibold px-10 py-4 rounded-md text-base md:text-lg tracking-wide hover:bg-copper-dark transition-colors whitespace-nowrap"
        >
          Shop Gift Ideas
        </Link>
      </div>
    </section>
  );
}